import { render, staticRenderFns } from "./deliveryDate.vue?vue&type=template&id=65ee4956"
import script from "./deliveryDate.vue?vue&type=script&lang=js"
export * from "./deliveryDate.vue?vue&type=script&lang=js"
import style0 from "./deliveryDate.vue?vue&type=style&index=0&id=65ee4956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports